/* eslint-disable array-callback-return */
/* eslint-disable no-redeclare */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
import React from 'react';

const ViewPODButton = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.onClickViewPOD(props);
        if (props.data.pod_document !== "" && props.data.pod_document !== undefined) {
            var docvie = props.data.pod_document;
            console.log("docvie ", docvie);
        } else {
            console.log("No document to view");
        }
    };

    // Enabled whenever an actual file is on record (pod_document) - that's the one thing this
    // button opens, so it's the correct signal, not is_submitted_pod/epod_gate. Those two get
    // unset by an OCR-failure revert while pod_document is meant to survive, so a rejected e-POD
    // stays viewable (the admin needs to see exactly what was uploaded and why OCR rejected it).
    const hasDocument = !!props.data.pod_document && props.data.pod_document !== "";
    return (
        <button onClick={handleClick} className="btn btn-success" style={{padding: "2px 10px", fontSize: "13px", margin: "0"}} title="View Pod" disabled={!hasDocument}>View POD</button>
    );
};

export default ViewPODButton;

